module.exports = __webpack_public_path__ + "img/pay-icon-4.5767c37b.png";